const SectionLevel = {
	section: 'section',
	department: 'department',
};

export default SectionLevel;
